// extracted by mini-css-extract-plugin
export default {"page":"fna-z","cartModal":"gna-z","checkout":"hna-z","placeholder":"ina-z","account":"jna-z"};